import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  FiUserPlus,
  FiLogOut,
  FiGlobe,
  FiGrid,
} from "react-icons/fi";
import Logo from "../assets/coozmoo-fav.png";
import BrandsMenu from "./BrandsMenu";

interface SidebarProps {
  onLogout: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ onLogout }) => {
  const navigate = useNavigate();
  const [showBrandsMenu, setShowBrandsMenu] = useState(false);
  const [userRole, setUserRole] = useState<string>("");
  const [brands, setBrands] = useState<Array<{ name: string; autologin_url: string }>>([]);
  const userId = localStorage.getItem("userid");

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    const brands = localStorage.getItem("brands");
    if (userRole) setUserRole(userRole);
    if (brands) setBrands(JSON.parse(brands));
  }, []);

  const handleLogoClick = () => navigate("/dashboard");
  const handleAddCustomer = () => navigate("/add-customer");
  const handleAccessUrl = () => navigate("/access-url");


  const iconStyle: React.CSSProperties = {
    color: "#333",
    transition: "all 0.2s ease-in-out",
  };

  const buttonStyle: React.CSSProperties = {
    border: "none",
    background: "transparent",
    padding: "8px",
    borderRadius: "10px",
    transition: "all 0.2s ease-in-out",
  };

  const hoverEffect = {
    backgroundColor: "#e6f4ea",
    color: "#7CBA2A",
  };

  const handleBrandClick = async () => {
    setShowBrandsMenu(true);

    try {
      const response = await fetch(`https://api.performancedashboard.io/api/metricool/customers/${userId}`, {
        method: "GET",
        credentials: "include",
      });

      if (!response.ok) {
        const text = await response.text();
        throw new Error(`Error fetching customers: ${response.status} - ${text.substring(0, 200)}`);
      }

      const data: any = await response.json();

      if (data?.brands) {
        setBrands(data.brands);
      }
      console.log(data);
    } catch (err: any) {
      console.error("Error fetching customers:", err);
    }

  };

  return (
    <div
      style={{
        width: "90px",
        backgroundColor: "#ffffff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "20px 0",
        borderRight: "1px solid #e5e5e5",
        boxShadow: "2px 0 5px rgba(0,0,0,0.05)",
      }}
    >
      {/* Logo */}
      <div onClick={handleLogoClick} style={{ cursor: "pointer" }}>
        <Image src={Logo} alt="Coozmoo Logo" height={40} />
      </div>

      {/* Sidebar Menu */}
      <div style={{ display: "flex", flexDirection: "column", gap: "18px", alignItems: "center" }}>
        {userRole === "super_admin" && (
          <>
            {/* Add Customer */}
            <OverlayTrigger placement="right" overlay={<Tooltip>Manage Customer</Tooltip>}>
              <Button
                variant="link"
                onClick={handleAddCustomer}
                style={buttonStyle}
                onMouseEnter={(e) =>
                  Object.assign(e.currentTarget.style, hoverEffect)
                }
                onMouseLeave={(e) =>
                  Object.assign(e.currentTarget.style, buttonStyle)
                }
              >
                <FiUserPlus size={22} style={iconStyle} />
              </Button>
            </OverlayTrigger>

            {/* Access URL */}
            <OverlayTrigger placement="right" overlay={<Tooltip>Manage URLs</Tooltip>}>
              <Button
                variant="link"
                onClick={handleAccessUrl}
                style={buttonStyle}
                onMouseEnter={(e) =>
                  Object.assign(e.currentTarget.style, hoverEffect)
                }
                onMouseLeave={(e) =>
                  Object.assign(e.currentTarget.style, buttonStyle)
                }
              >
                <FiGlobe size={22} style={iconStyle} />
              </Button>
            </OverlayTrigger>
          </>
        )}

        {/* Brands */}
        <OverlayTrigger placement="right" overlay={<Tooltip>Brands</Tooltip>}>
          <Button
            variant="link"
            onClick={() => handleBrandClick()}
            style={buttonStyle}
            onMouseEnter={(e) =>
              Object.assign(e.currentTarget.style, hoverEffect)
            }
            onMouseLeave={(e) =>
              Object.assign(e.currentTarget.style, buttonStyle)
            }
          >
            <FiGrid size={22} style={iconStyle} />
          </Button>
        </OverlayTrigger>

        {/* Logout */}
        <OverlayTrigger placement="right" overlay={<Tooltip>Logout</Tooltip>}>
          <Button
            variant="link"
            onClick={onLogout}
            style={buttonStyle}
            onMouseEnter={(e) =>
              Object.assign(e.currentTarget.style, {
                backgroundColor: "#ffe8e8",
                color: "#dc3545",
              })
            }
            onMouseLeave={(e) =>
              Object.assign(e.currentTarget.style, buttonStyle)
            }
          >
            <FiLogOut size={22} style={{ ...iconStyle, color: "#dc3545" }} />
          </Button>
        </OverlayTrigger>
      </div>

      {/* Brands Drawer */}
      <BrandsMenu
        show={showBrandsMenu}
        onHide={() => setShowBrandsMenu(false)}
        brands={brands}
      />
    </div>
  );
};

export default Sidebar;
